import { analytics } from '@helpers/analytics'
import MediaItem, { MediaItemProps } from '@components/ui/Medias/MediaItem'
import styles from './styles.module.scss'

type HeroVideoBannerProps = {
  media: MediaItemProps
  category?: string
}

function HeroVideoBanner({ media, category }: HeroVideoBannerProps) {
  const handleMediaItemClick = () => {
    const props = {
      action: `Hero Video`,
      category: category || '',
      label: 'Hero Video'
    }
    analytics('Click', props)
  }

  return (
    <div className={styles.HeroVideoBanner}>
      <MediaItem {...media} onClick={handleMediaItemClick} />
    </div>
  )
}

export default HeroVideoBanner
